import React from "react";
import { Box, Typography, useTheme } from "@material-ui/core";

import { useAppSelector } from "store";
import { selectComparatorsByChapter } from "modules/customer/tools/location/locationSlice";
import { selectIsLoading, selectHasErrors, selectMostCommonStoreSize } from "modules/customer/tools/location/retailers/retailersSlice";


import useColourPalette from "components/visuals/useColourPalette";
import KPIComparison from "components/visuals/KPIComparison";

const MostCommonStoreSize = () => {
    const theme = useTheme();
    const colourPalette = useColourPalette();
    const selectedComparator = useAppSelector(selectComparatorsByChapter)?.retailers;
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const numberOfStores = useAppSelector(selectMostCommonStoreSize);
    const pinnedLocationSizeBucket = numberOfStores?.pinnedLocation;
    const comparatorSizeBucket = numberOfStores?.comparator;
    const pinnedLocationFormattedValue = pinnedLocationSizeBucket ? `${pinnedLocationSizeBucket?.label} (${pinnedLocationSizeBucket?.sizeRange})` : "Unknown";
    const comparatorFormattedValue = comparatorSizeBucket ? `${comparatorSizeBucket?.label} (${comparatorSizeBucket?.sizeRange})` : "Unknown";
    const label = "Most common store size in your selected location's Retail Zone";

    return (
        <Box width="100%" height="100%" data-cy="number-of-stores-in-retail-zone">
            <KPIComparison
                isLoading={isLoading}
                hasErrors={hasErrors}
                targetValue={
                    <Typography variant="h4" component="div" style={{ color: colourPalette.comparators[0], fontWeight: theme.typography.fontWeightMedium }}>
                        {pinnedLocationFormattedValue}
                    </Typography>
                }
                targetLabel={label}
                comparisonValue={
                    <Typography variant="h6" component="div" style={{ color: colourPalette.comparators[1] }}>
                        {comparatorFormattedValue}
                    </Typography>
                }
                comparisonLabel={`Comparator: ${selectedComparator?.storeName} `}
            />
        </Box>
    );
};

export default MostCommonStoreSize;
